module.exports = __webpack_public_path__ + "img/kiwoom_main_slide3.29eee81d.png";